import { WorkoutPopup } from '../programmes/programme-workout-popup'
import { WorkoutCard } from '../ui/workout-card'
import React, { useContext, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { SessionContext } from 'src/context/session-context'
import { Workout } from 'src/dao/core-dao'

const CoreChargeWorkoutHomeCard = ({
  workout,
  selectWorkout,
}: {
  workout: Workout
  selectWorkout?: () => void
}): React.ReactElement => {
  const { completedWorkoutIds } = useContext(SessionContext)

  return (
    <WorkoutCard.CoreCharge
      workout={workout}
      isCompleted={completedWorkoutIds.has(workout.id)}
      onAction={() => selectWorkout?.()}
      className="w-full h-full"
    />
  )
}

export const CoreChargeWorkoutCardList = ({ workouts }: { workouts: Workout[] }): React.ReactElement => {
  const [selectedWorkout, setSelectedWorkout] = useState<Workout | undefined>(undefined)

  return (
    <Container fluid className="px-0">
      <Row>
        {workouts.map((workout, index) => (
          <Col key={workout.id} xs={12} lg={index === 0 ? 6 : 3} className="mb-7 lg:mb-0">
            <div className="h-full">
              <CoreChargeWorkoutHomeCard workout={workout} selectWorkout={() => setSelectedWorkout(workout)} />
            </div>
          </Col>
        ))}
        <WorkoutPopup
          setOnClose={() => setSelectedWorkout(undefined)}
          selectedWorkout={selectedWorkout}
          startWorkoutLink={selectedWorkout ? `/workouts/${selectedWorkout?.id}` : undefined}
        />
      </Row>
    </Container>
  )
}
